/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { ContentHelper } from '@app/app/shared/helpers/content-helper';
import { VersionHelper } from '@app/app/shared/helpers/version.helper';

/** The backend builds `ShareDetails.path` from the same routes. */
export const SHARED_WORK_ROOT = 'shared';
export const PUBLIC_SHARED_WORK_PREFIX = `/${SHARED_WORK_ROOT}/assignments/p/`;
export const MY_SHARED_WORK_PATH = `/${SHARED_WORK_ROOT}/mine`;

export function sharedWorkPath(shareId: string): string {
  return `/${SHARED_WORK_ROOT}/assignments/${shareId}`;
}

export function isPublicSharedWorkUrl(pathname: string): boolean {
  return pathname.startsWith(PUBLIC_SHARED_WORK_PREFIX);
}

/** LMS launches and V2 orgs can't reach the Evidence page, so they get the frameless page. */
export function mySharedWorkUrl(): string {
  return ContentHelper.isFrameMode() || !VersionHelper.isV3Enabled() ? MY_SHARED_WORK_PATH : '/evidence?tab=shared';
}
